module.exports = __webpack_public_path__ + "static/media/deya_raghavan.4adddc45.png";